<template>
    <div
        v-if="show"
        class="fixed z-[200] bg-white rounded-2xl shadow-2xl border border-gray-100 w-64 overflow-hidden"
        :style="{ top: top + 'px', left: left + 'px', height: 'auto' }"
    >
        <!-- Backdrop: click outside closes popup -->
        <div class="fixed inset-0 z-[-1]" @click="$emit('close')"></div>

        <!-- Header with avatar + name -->
        <div class="flex items-center gap-3 p-4 bg-gray-50 border-b border-gray-100">
            <img
                :src="senderAvatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(senderName || '')}&background=random`"
                class="h-12 w-12 rounded-full object-cover shadow-sm flex-shrink-0"
                :alt="senderName"
            />
            <div class="min-w-0">
                <p class="font-bold text-gray-900 text-sm leading-tight truncate">{{ senderName }}</p>
                <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mt-0.5">{{ senderKind === 'buyer' ? 'Käufer' : 'Immivo Advisor' }}</p>
            </div>
        </div>

        <!-- Contact details -->
        <div class="p-4 space-y-2.5">
            <a
                v-if="senderEmail"
                :href="`mailto:${senderEmail}`"
                class="flex items-center gap-2.5 text-xs text-gray-600 hover:text-blue-600 transition-colors group"
            >
                <MailIcon class="h-4 w-4 text-gray-300 group-hover:text-blue-400 flex-shrink-0 transition-colors" />
                <span class="truncate">{{ senderEmail }}</span>
            </a>
            <a
                v-if="senderMobile"
                :href="`tel:${senderMobile}`"
                class="flex items-center gap-2.5 text-xs text-gray-600 hover:text-blue-600 transition-colors group"
            >
                <PhoneIcon class="h-4 w-4 text-gray-300 group-hover:text-blue-400 flex-shrink-0 transition-colors" />
                <span class="truncate">{{ senderMobile }}</span>
            </a>
        </div>
    </div>
</template>

<script>
import { MailIcon, PhoneIcon } from "@heroicons/vue/outline";

export default {
    name: 'ChatAdvisorPopup',
    components: { MailIcon, PhoneIcon },
    props: {
        show:         { type: Boolean, required: true },
        senderName:   { type: String, default: '' },
        senderAvatar: { type: String, default: '' },
        senderEmail:  { type: String, default: '' },
        senderMobile: { type: String, default: null },
        top:          { type: Number, default: 0 },
        left:         { type: Number, default: 0 },
        senderKind:   { type: String, default: 'advisor' },
    },
    emits: ['close']
};
</script>
